import { render } from "./ClienteForm.vue?vue&type=template&id=ebe79fc4&scoped=true"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"

import "./ClienteForm.vue?vue&type=style&index=0&id=ebe79fc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe79fc4"]])

export default __exports__